import Alpine from "alpinejs";
import * as utils from "../../editor/v2/utils/sharedUtils";

Alpine.data("icon", () => ({
    uuid: null,
    iconSize: '',

    configuration: {
        icon: '',
        horizontalAlign: 'left',

        iconSize: {
            desktop: '',
            tablet: '',
            mobile: ''
        },

        color: {
            normal: '',
            hover: ''
        },

        link: {
            type: 'internal',
            email: '',
            tel: '',
            target: '_self',
            noFollow: false,
            external: '',
            internal: ''
        },

        backgroundStyle: utils.createBackgroundStyles()
    },

    init(uuid, configuration) {
        if (configuration) {
            this.configuration = configuration;
            this.calculateIconSize();
        }

        if (uuid) {
            this.uuid = uuid;
        }

        // Attach a message listener to reinitialize sliders dynamically
        window.addEventListener('message', (event) => {
            if (event.data.type === 'change-icon') {
                let json = JSON.parse(event.data.data);

                if (json.id === this.uuid) {
                    this.configuration = json.configuration;
                    this.calculateIconSize();
                }
            }
        });

        const mediaQueries = [
            '(max-width: 767px)',
            '(min-width: 768px) and (max-width: 1024px)',
            '(min-width: 1025px)'
        ];
        mediaQueries.forEach(query =>
            window.matchMedia(query).addEventListener('change', this.calculateIconSize.bind(this))
        );
    },

    calculateIconSize() {
        if (window.matchMedia('(max-width: 767px)').matches) {
            // Styles for mobile screens
            this.iconSize = this.configuration.iconSize.mobile + 'px';
        } else if (window.matchMedia('(min-width: 768px) and (max-width: 1024px)').matches) {
            // Styles for tablet screens
            this.iconSize =  this.configuration.iconSize.tablet + 'px';
        } else {
            // Styles for desktop screens
            this.iconSize = this.configuration.iconSize.desktop + 'px';
        }
    }

}));